/*
  Bundle discount tiers — the single place the percentages are defined.

  Read by bundle-tiered-discounts.js (the "Popular upgrades" list and the bundle
  builder) and by upsell-popup.js. The discounts themselves are automatic discounts
  configured in the Shopify admin; these tiers only drive the messaging, so they have
  to stay in step with what the admin actually grants.

  Counts are totals: every unit that ends up in the cart, main product included.
*/

(function () {
  if (window.BundleTiers) return;

  const TIERS = [
    { minItems: 3, percent: 10 },
    { minItems: 4, percent: 15 }
  ];

  const byMinItems = (a, b) => a.minItems - b.minItems;

  window.BundleTiers = {
    get tiers() {
      return TIERS.map((tier) => ({ ...tier }));
    },

    /* The same tiers as seen by a counter that leaves items out of its count — the
       checkbox list on the product page counts its own checkboxes only, so the product
       of the page is one item it never sees. */
    shifted(offset) {
      return TIERS.map((tier) => ({ ...tier, minItems: tier.minItems - (offset || 0) }));
    },

    // Highest tier reached. Stays at the last one once passed.
    current(count, tiers) {
      const sorted = (tiers || this.tiers).slice().sort(byMinItems).reverse();

      return sorted.find((tier) => count >= tier.minItems) || null;
    },

    // The next tier still to unlock, or null once the top one is reached.
    next(count, tiers) {
      const sorted = (tiers || this.tiers).slice().sort(byMinItems);

      return sorted.find((tier) => count < tier.minItems) || null;
    },

    savings(total, percent) {
      if (!total || !percent) return 0;

      return Math.round((total * percent) / 100);
    }
  };
})();
